import React from 'react';


const NotFoundFun = () => (
  <div className="notfound-fun d-flex flex-column justify-content-center align-items-center text-center px-3">
    <div className="robot" role="img" aria-label="robot icon">
      🤖
    </div>
    <h1 className="mb-2">404</h1>
    <h3 className="mb-3">Uh-oh! Lost in cyberspace?</h3>
    <p className="mb-4 px-2">
      This page seems to have taken a detour. Let's get you back on track!
    </p>
    <a href="/" className="btn btn-warning btn-lg animated-btn">
      Take Me Back
    </a>
  </div>
);

export default NotFoundFun;
